/**
 * Z-Index hierarchy for Patient Overview V2 components.
 * Keep this file updated when adding new layered components to prevent conflicts.
 *
 * Hierarchy (bottom to top):
 * - Page content (0)
 * - Sticky header (4)
 * - Side panel backdrop (1400)
 * - Side panel content (1401)
 * - PDF modal backdrop (1500)
 * - PDF modal content (1501)
 */

export const Z_INDEX = {
  /** Sticky header with search and tabs */
  STICKY_HEADER: 4,

  /** Side panel (drawer) backdrop - dims the main content */
  SIDE_PANEL_BACKDROP: 1400,

  /** Side panel (drawer) content */
  SIDE_PANEL_CONTENT: 1401,

  /** Side panel (drawer) resource documents menu */
  SIDE_PANEL_RESOURCE_DOCUMENTS_MENU: 1402,

  /** PDF viewer modal backdrop - dims side panel + main content */
  PDF_MODAL_BACKDROP: 1500,

  /** PDF viewer modal content - appears above everything */
  PDF_MODAL_CONTENT: 1501,
} as const;
